<template>
<div class="chapter">
<div class="inner_page">
<h2 class="title" id="calibre_pb_0">Das weiße Haus</h2>
<h4 class="calibre1">Roman</h4>
<p class="calibre2"> </p>
<p class="calibre2"> </p>
<div class="motto">
<p class="calibre2"><a id="page6" title="wolfeh/wedi"></a> Tell me the
tales,<br class="calibre3"/>
that to me were so dear,<br class="calibre3"/>
long, long ago –<br class="calibre3"/>
long, long ago. <a id="page7" title="wolfeh/wedi"></a></p>
</div>
<p class="calibre2"> </p>
<p class="calibre2"> </p>
<p class="calibre2"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter0_split_001.vue?f40e36ce